import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { companyApi } from '../companyApi';
import type { UpdateCompanyParams, Company } from '../types';
import { MutationKey } from '@shared/config';
import type { TFormErrorResponse } from '@shared/types';
import { AxiosError } from 'axios';

export const useUpdateCompany = (
  id: string
): UseMutationResult<
  Company,
  AxiosError<TFormErrorResponse>,
  UpdateCompanyParams
> => {
  return useMutation({
    mutationKey: [MutationKey.UPDATE_COMPANY],
    mutationFn: (params: UpdateCompanyParams) =>
      companyApi.updateCompany(id, params),
  });
};
